import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes as Switch } from "react-router-dom";
import DetailsRoute from "./Details";
import HomeRoute from "./Home";
import PageNotFoundRoute from "routes/404/NotFoundRoute";

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route path="/:type/:id" element={<HomeRoute />}></Route>
        <Route path="/:type/:id/details" element={<DetailsRoute />}></Route>
        <Route path="/404" element={<PageNotFoundRoute />}></Route>
        <Route path="*" element={<Navigate to={`/404`} />}></Route>
      </Switch>
    </Router>
  );
};

export default Routes;
